<template>
  <div>
    <div style="padding: 10px; min-height: 100px">
      <x-table
        listApi="biz.customer.account.info.list"
        paginationLayout="total, sizes, prev, next, jumper"
        defaultSort="opt_status asc"
        actionFixed="right"
        emptyLabel="暂无账号信息"
        :btnList="btnList"
        :defaultParams="defaultParams"
        :fieldList="fieldList"
        :actionList="actionList"
        :paramList="paramList"
        :actionWidth="220"
      >
        <template slot="row-role" slot-scope="scope">
          <div>
            <el-tag
              v-if="scope.row.optSuper == 1"
              style="margin-left: 5px"
              size="small"
              type="primary"
            >
              超级管理员
            </el-tag>
            <el-tag
              v-else-if="scope.row.roleInfo"
              style="margin-left: 5px"
              size="small"
              type="info"
            >
              {{ scope.row.roleInfo.roleName || "" }}
            </el-tag>
          </div>
        </template>
        <template slot="row-info" slot-scope="scope">
          <div>
            <span>
              {{ scope.row.username }}
            </span>
            <el-tag
              v-if="scope.row.guid == readState('userProfile.guid')"
              style="margin-left: 5px"
              size="small"
              type="info"
            >
              自己
            </el-tag>
          </div>
          <div style="color: #919191">
            {{
              [scope.row.nickname, scope.row.optRemark]
                .filter((item) => !!item)
                .join(" | ")
            }}
          </div>
        </template>
      </x-table>
    </div>
  </div>
</template>

<script>
import extrasPage from './__account_extras.vue';
import formPage from "./__account_form.vue";
import customerRolePage from "../_inner-customer-role/index.vue";

export default {
  props: {
    params: {
      type: Object,
      default: () => ({}),
    },
    query: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    defaultParams() {
      return {
        customerGuid: this.pageParams.customerGuid
      };
    },
    pageParams() {
      return Object.assign(
        {},
        (this.$route && this.$route.params) || {},
        this.params
      );
    },
    pageQuery() {
      return Object.assign(
        {},
        (this.$route && this.$route.query) || {},
        this.query
      );
    },
  },
  data() {
    return {
      paramList: [
      ],
      fieldList: [
        {
          label: "账号信息",
          minWidth: "200",
          slot: 'info',
        },
        {
          label: "账号角色",
          width: "150",
          slot: 'role',
        },
        {
          label: '状态',
          type: 'tag',
          width: '100',
          size: 'mini',
          render: row => (row.optStatus == 1 ? '正常' : '禁用'),
          tagType: row => (row.optStatus == 1 ? 'success' : 'danger'),
        },
      ],
      actionList: [
        {
          label: '编辑',
          disabled: row => (
            row.guid == this.readState('userProfile.guid')
          ),
          show: (row) => {
            if (!this.$hasPower([
              "optSuper"
            ])) {
              return false;
            };
            return true
          },
          click: (row, tag, refresh) => {
            this.$drawer.openDrawer({
              title: '编辑账号信息',
              refresh,
              component: formPage,
              params: {
                guid: row.guid
              },
            });
          },
        },
        {
          label: '权限',
          show: (row) => {
            if (!this.$hasPower([
              "optSuper"
            ])) {
              return false;
            };
            return !row.optSuper
          },
          click: (row, tag, refresh) => {
            this.$drawer.openDrawer({
              title: '账号门店权限编辑',
              refresh,
              component: extrasPage,
              params: {
                guid: row.guid,
              },
            });
          },
        },
        {
          label: row => (row.optStatus == 1 ? '禁用' : '启用'),
          disabled: row => (
            row.guid == this.readState('userProfile.guid')
          ),
          click: (row, tag, refresh) => {
            const label = row.optStatus == 1 ? '禁用' : '启用';
            this.$confirm(`确定${label}?`, '提示', {
              type: 'warning',
            }).then(() => {
              this.requestApi('biz.customer.account.info.update', {
                guid: row.guid,
                optStatus: row.optStatus == 1 ? 0 : 1,
              }, {
                showError: true
              }).then(() => {
                this.success('保存成功');
                refresh && refresh();
              });
            });
          },
        },
        {
          label: '删除',
          linkType: 'danger',
          disabled: row => (
            row.guid == this.readState('userProfile.guid')
          ),
          show: (row) => {
            if (!this.$hasPower([
              "optSuper"
            ])) {
              return false;
            };
            return true
          },
          click: (row, tag, refresh) => {
            this.$confirm('确定删除?', '提示', {
              type: 'warning',
            }).then(() => {
              this.requestApi('biz.customer.account.info.delete', { guid: row.guid }, {
                showError: true
              }).then(() => {
                this.success('删除成功');
                this.$drawer.refreshDrawer();
                refresh && refresh();
              });
            });
          },
        },
      ],
      btnList: [
        {
          label: '新增账号',
          type: 'primary',
          show: (row) => {
            if (!this.$hasPower([
              "optSuper"
            ])) {
              return false;
            };
            return true
          },
          click: (row, tag, refresh) => {
            this.$drawer.openDrawer({
              title: '新增账号',
              refresh,
              component: formPage,
              params: this.defaultParams,
            });
          },
        },
        {
          label: '角色管理',
          type: 'default',
          show: (row) => {
            if (!this.$hasPower([
              "optSuper"
            ])) {
              return false;
            };
            return true
          },
          click: (row, tag, refresh) => {
            this.$drawer.openDrawer({
              title: '角色管理',
              refresh,
              component: customerRolePage,
              params: this.defaultParams,
            });
          },
        },
      ],
    };
  },
};
</script>
